import { t } from 'i18next'

type AdSizeTypeOption = {
  value: AdSizeType
  label: string
}

export const adSizeTypeOptions: AdSizeTypeOption[] = [
  {
    value: 'image',
    label: t('rm:adsize.form.text.type.image')
  },
  {
    value: 'video',
    label: t('rm:adsize.form.text.type.video')
  },
  {
    value: 'digital_signage',
    label: t('rm:adsize.form.text.type.digital_signage')
  },
  {
    value: 'sponsored_brand_image',
    label: t('rm:adsize.form.text.type.sponsored_brand_image')
  },
  {
    value: 'sponsored_brand_video',
    label: t('rm:adsize.form.text.type.sponsored_brand_video')
  }
]
